import React from 'react';

import { useSnackbar } from 'notistack';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { useDeleteServiceFee } from '~/hooks/apis/business-traveller/useDeleteServiceFee';

interface Props {
  businessId: string;
  serviceFeeId: string;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function BusinessServiceFeesDeleteModal({
  businessId,
  serviceFeeId,
  isOpen,
  onClose,
  onSuccess,
}: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const deleteMutation = useDeleteServiceFee();

  const handleDelete = () => {
    deleteMutation.mutate(
      { businessId, serviceFeeId },
      {
        onSuccess: () => {
          enqueueSnackbar('Service fee removed successfully', { variant: 'success' });
          onSuccess();
          onClose();
        },
        onError: (error) => {
          const message = error instanceof Error ? error.message : JSON.stringify(error, null, 2);
          enqueueSnackbar(`Error removing service fee [${message}]`, { variant: 'error' });
        },
      },
    );
  };

  const isLoading = deleteMutation.isPending;

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        if (!isLoading) {
          onClose();
        }
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Remove Service Fee</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Are you sure you want to remove this service fee?</Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} variant="text" onClick={onClose}>
          No
        </Button>
        <Button onClick={handleDelete} disabled={isLoading} variant="contained" color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
